module.exports = __webpack_public_path__ + "img/wallet.36d7f9e0.png";